module.exports = __webpack_public_path__ + "img/pigai-title-03.01934f1d.png";